import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { authApi, metricsApi, metricsProviderApi, settingsApi, usersApi } from '@vxui/common';
import { configApi } from '../services';
import { toastMiddleware } from './toast.middleware';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [configApi.reducerPath]: configApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [metricsApi.reducerPath]: metricsApi.reducer,
    [metricsProviderApi.reducerPath]: metricsProviderApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      configApi.middleware,
      settingsApi.middleware,
      metricsApi.middleware,
      metricsProviderApi.middleware,
      authApi.middleware,
      usersApi.middleware,
      toastMiddleware,
    ),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
